webpackJsonp([8],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Login page
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContentRoot = __webpack_require__(91);
	
	var _getContentRoot2 = _interopRequireDefault(_getContentRoot);
	
	var _Window = __webpack_require__(83);
	
	var _Window2 = _interopRequireDefault(_Window);
	
	var _getTranslations = __webpack_require__(57);
	
	var _getTranslations2 = _interopRequireDefault(_getTranslations);
	
	var _acura = __webpack_require__(67);
	
	var _acura2 = _interopRequireDefault(_acura);
	
	var _cms = __webpack_require__(80);
	
	var _parseLayoutCmsData = __webpack_require__(92);
	
	var _parseLayoutCmsData2 = _interopRequireDefault(_parseLayoutCmsData);
	
	var _readConfigData = __webpack_require__(64);
	
	var _readConfigData2 = _interopRequireDefault(_readConfigData);
	
	var _AcuraResponsiveLayout = __webpack_require__(156);
	
	var _AcuraResponsiveLayout2 = _interopRequireDefault(_AcuraResponsiveLayout);
	
	var _geo = __webpack_require__(58);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cmsData = (0, _cms.parseData)(window.__pageContentData || {});
	var appCmsData = _extends({}, (0, _parseLayoutCmsData2.default)(cmsData));
	
	var config = (0, _readConfigData2.default)('acura-config');
	
	var app = (0, _lodash.assign)({}, {
	  theme: _acura2.default,
	  isDesktop: false,
	  isMobile: false,
	  isResponsive: true,
	  modelsNavList: [],
	  env: ("production"),
	  version: ("3.4.5"),
	  outerContainerId: 'hui-layout-container',
	  pageWrapId: 'hui-content-container',
	  menuPanelWidth: 390,
	  vehiclePanelWidth: 780,
	  firstPanelId: 'contentMenu',
	  translations: (0, _getTranslations2.default)(config.language)
	}, config, appCmsData);
	
	renderApp(app);
	_geo2.default.init(app);
	
	function renderApp(props) {
	  _reactDom2.default.render(_react2.default.createElement(
	    _Window2.default,
	    props,
	    _react2.default.createElement(
	      _AcuraResponsiveLayout2.default,
	      props,
	      _react2.default.createElement(
	        'div',
	        { id: 'accountsApp', 'data-ng-cloak': true },
	        _react2.default.createElement(
	          'accounts-app',
	          null,
	          'Loading...'
	        )
	      )
	    )
	  ), (0, _getContentRoot2.default)('root'));
	}

/***/ })
]);


// WEBPACK FOOTER //
// login.js